export default __webpack_public_path__ + "static/media/SL_Physics.509493d2.svg";